import React, { useEffect, useState } from "react";
import DashboardLayout from "../DashboardLayout";
import ShowForexHistoryData from "./ShowForexHistoryData";
import apiClient from "../../utils/apiClient";
import server from "../../utils/serverConfig";

export default function ForexTradeHistoryPage() {
  const [userTradeHistory, setUserTradeHistory] = useState([]);
  const [userOrdersHistory, setUserOrderHistory] = useState([]);
  const [eqityTradeHistory, setEquityTradeHistory] = useState([]);
  const [equityOrderHistory, setEquityOrderHistory] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageTradeEquity, setCurrentPageTradeEquity] = useState(1);
  const [currentPageOrder, setCurrentPageOrder] = useState(1);
  const [currentPageOrderEquity, setCurrentPageOrderEquity] = useState(1);
  const [state, setState] = useState("fno");

  const fetchTradeHistory = (currentPage) => {
    let config = {
      method: "get",
      url: `${server.godseye.baseUrl}fyers-historical_trades_data?page=${currentPage}&type=fno`,
    };

    apiClient
      .request(config)
      .then((response) => {
        setUserTradeHistory(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fetchTradeHistoryEquity = (currentPageTradeEquity) => {
    let config = {
      method: "get",
      url: `${server.godseye.baseUrl}fyers-historical_trades_data?page=${currentPageTradeEquity}&type=equity`,
    };

    apiClient
      .request(config)
      .then((response) => {
        setEquityTradeHistory(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fetchOrderHistory = (currentPageOrder) => {
    let config = {
      method: "get",
      url: `${server.godseye.baseUrl}fyers-historical_orders_data?page=${currentPageOrder}&type=fno`,
    };

    apiClient
      .request(config)
      .then((response) => {
        setUserOrderHistory(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fetchEquityOrderHistory = (currentPageOrderEquity) => {
    let config = {
      method: "get",
      url: `${server.godseye.baseUrl}fyers-historical_orders_data?page=${currentPageOrderEquity}&type=equity`,
    };

    apiClient
      .request(config)
      .then((response) => {
        setEquityOrderHistory(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [allUser, setAllUser] = useState([]);

  const getAllAccountUser = () => {
    let config = {
      method: "get",
      url: "/api/fyers-user-token",
      headers: {
        "Content-Type": "application/json",
      },
    };

    apiClient
      .request(config)
      .then((response) => {
        setAllUser(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchTradeHistory(currentPage);
    fetchOrderHistory(currentPageOrder);
    fetchTradeHistoryEquity(currentPageTradeEquity);
    fetchEquityOrderHistory(currentPageOrderEquity);
    getAllAccountUser();
  }, [
    currentPage,
    currentPageOrder,
    currentPageTradeEquity,
    currentPageOrderEquity,
  ]);

  // console.log("dashboard Hsitory",userTradeHistory)

  return (
    <DashboardLayout>
      <div className="flex flex-col relative  w-full max-h-screen">
        <div className="flex flex-col flex-1 ">
          <ShowForexHistoryData
            forexTradesHistoryData={userTradeHistory}
            forexOrdersHistoryData={userOrdersHistory}
            setUserTradeHistory={setUserTradeHistory}
            eqityTradeHistory={eqityTradeHistory}
            equityOrderHistory={equityOrderHistory}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            currentPageOrder={currentPageOrder}
            setCurrentPageOrder={setCurrentPageOrder}
            currentPageTradeEquity={currentPageTradeEquity}
            setCurrentPageTradeEquity={setCurrentPageTradeEquity}
            currentPageOrderEquity={currentPageOrderEquity}
            setCurrentPageOrderEquity={setCurrentPageOrderEquity}
            allUser={allUser && allUser}
            setState={setState}
            state={state}
          />
        </div>
      </div>
    </DashboardLayout>
  );
}
